import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @file Modal header
 */
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
export const ModalHeader = ({ header, title, style, headerRight, closable, onCancel, onClose, }) => {
    if (header === null)
        return null;
    if (header)
        return _jsx(_Fragment, { children: header }, void 0);
    return (_jsxs(Wrapper, Object.assign({ style: style || {} }, { children: [_jsx(ModalTitle, { children: title }, void 0), _jsxs(ModalHeaderRight, { children: [headerRight, closable && (_jsx(ModalClose, Object.assign({ "data-test-id": 'close-modal', onClick: e => {
                            if (onClose)
                                onClose();
                            else
                                onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
                        } }, { children: _jsx(ModalCloseIcon, { className: "se-modal-close-icon", icon: faTimes }, void 0) }), void 0))] }, void 0)] }), void 0));
};
const Wrapper = styled.div `
  display: flex;
  flex: 0 0 56px;
  align-items: center;
  justify-content: space-between;
  padding-left: 24px;
  background-color: ${p => p.theme.background._3};
  border-radius: 6px 6px 0 0;
`;
const ModalTitle = styled.span `
  color: ${p => p.theme.text._1};
  font-weight: bold;
  font-size: 18px;
`;
const ModalHeaderRight = styled.div `
  display: flex;
  align-items: center;
`;
const ModalClose = styled.button `
  width: 56px;
  height: 56px;
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;

  &:hover {
    .se-modal-close-icon {
      color: ${p => p.theme.text._1};
    }
  }
`;
const ModalCloseIcon = styled(FontAwesomeIcon) `
  color: ${p => p.theme.text._3};
  font-size: 22px;
  cursor: pointer;
  transition: color 0.3s;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL01vZGFsL0hlYWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOztHQUVHO0FBRUgsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLG9DQUFvQyxDQUFBO0FBQzVELE9BQU8sRUFBRSxlQUFlLEVBQUUsTUFBTSxnQ0FBZ0MsQ0FBQTtBQUVoRSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQTtBQUl0QyxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQStCLENBQUMsRUFDdEQsTUFBTSxFQUNOLEtBQUssRUFDTCxLQUFLLEVBQ0wsV0FBVyxFQUNYLFFBQVEsRUFDUixRQUFRLEVBQ1IsT0FBTyxHQUNSLEVBQUUsRUFBRTtJQUNILElBQUksTUFBTSxLQUFLLElBQUk7UUFBRSxPQUFPLElBQUksQ0FBQTtJQUVoQyxJQUFJLE1BQU07UUFBRSxPQUFPLDRCQUFHLE1BQU0sV0FBSSxDQUFBO0lBRWhDLE9BQU8sQ0FDTCxNQUFDLE9BQU8sa0JBQUMsS0FBSyxFQUFFLEtBQUssSUFBSSxFQUFFLGlCQUN6QixLQUFDLFVBQVUsY0FBRSxLQUFLLFdBQWMsRUFDaEMsTUFBQyxnQkFBZ0IsZUFDZCxXQUFXLEVBQ1gsUUFBUSxJQUFJLENBQ1gsS0FBQyxVQUFVLGtDQUNLLGFBQWEsRUFDM0IsT0FBTyxFQUFFLENBQUMsQ0FBQyxFQUFFOzRCQUNYLElBQUksT0FBTztnQ0FBRSxPQUFPLEVBQUUsQ0FBQTs7Z0NBQ2pCLFFBQVEsYUFBUixRQUFRLHVCQUFSLFFBQVEsQ0FBRyxDQUFDLENBQUMsQ0FBQTt3QkFDcEIsQ0FBQyxnQkFFRCxLQUFDLGNBQWMsSUFBQyxTQUFTLEVBQUMscUJBQXFCLEVBQUMsSUFBSSxFQUFFLE9BQU8sV0FBSSxZQUN0RCxDQUNkLFlBQ2dCLGFBQ1gsQ0FDWCxDQUFBO0FBQ0gsQ0FBQyxDQUFBO0FBRUQsTUFBTSxPQUFPLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQTs7Ozs7O3NCQU1KLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxVQUFVLENBQUMsRUFBRTs7Q0FFL0MsQ0FBQTtBQUVELE1BQU0sVUFBVSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUE7V0FDbkIsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFOzs7Q0FHOUIsQ0FBQTtBQUVELE1BQU0sZ0JBQWdCLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQTs7O0NBR2xDLENBQUE7QUFFRCxNQUFNLFVBQVUsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFBOzs7Ozs7Ozs7Ozs7ZUFZakIsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFOzs7Q0FHbEMsQ0FBQTtBQUVELE1BQU0sY0FBYyxHQUFHLE1BQU0sQ0FBQyxlQUFlLENBQUMsQ0FBQTtXQUNuQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEVBQUU7Ozs7Q0FJOUIsQ0FBQSJ9